<!--~
  ~ Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div role="group" class='number-range-container'
     [formGroup]="range"
     [attr.aria-labelledby]="parentFormField?.getLabelId()">
    <ng-container *ngIf="shouldDisplaySelect">
        <mat-form-field>
            <mat-label>Min:</mat-label>
            <mat-select #minSelect
                        [compareWith]="compareValueFn"
                        formControlName='min'>
                <mat-option [value]='undefined'>-- Select --</mat-option>
                <mat-option *ngFor="let opt of options" [value]="opt.value">{{opt.text}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Max:</mat-label>
            <mat-select #maxSelect
                        [compareWith]="compareValueFn"
                        formControlName='max'>
                <mat-option [value]='undefined'>-- Select --</mat-option>
                <mat-option *ngFor="let opt of options" [value]="opt.value">{{opt.text}}</mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>
    <ng-container *ngIf="!shouldDisplaySelect">
        <mat-form-field>
            <mat-label>Min:</mat-label>
            <input matInput class="number-range-min"
                   formControlName="min"
                   aria-label="Min"
                   [placeholder]="minPlaceholder"
                   (input)="handleInput(range.controls.min, max)"
                   #min>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Max:</mat-label>
            <input matInput class="number-range-max"
                   formControlName="max"
                   aria-label="Max"
                   [placeholder]="maxPlaceholder"
                   (input)="handleInput(range.controls.max)"
                   #max>
        </mat-form-field>
    </ng-container>
</div>